import * as d3 from 'd3'

export default {
  methods: {

    chart_Controller(chtData, cht) {         
      let actData = chtData.filter(f => f.CDATE <= this.timeline.cutoff.date)
      let fcData = chtData.filter(f => f.CDATE >= this.timeline.cutoff.date)

      let charts = this.canvasChart
        .append('g')
        .attr('transform', `translate(${cht.x}, ${cht.y + this.chart.y})`)

      // Bar Chart
      this.chart.styles.filter(f => f.type == 'BAR').forEach((st, i) => {
        let data = chtData
        if (st.sch == 'A') data = actData
        else if (st.sch == 'F') data = fcData
        else if (st.sch) data = this.getScheduleData(chtData, st.sch, this.timeline.cutoff.date)
        this.draw_BarChart(charts, data, st, i)
      })

      // Line Chart
      this.chart.styles.filter(f => f.type == 'LINE').forEach((st, i) => {
        let data = chtData
        if (st.sch == 'A') data = actData
        else if (st.sch == 'F') data = fcData
        else if (st.sch) data = this.getScheduleData(chtData, st.sch, this.timeline.cutoff.date)
        
        this.draw_LineChart(charts, data, st)

        if (Object.keys(this.summary).length > 0) {
          if (this.chart.lastValue.tSize > 0 && st.sch == 'A' && (this.summary.apply != 'Y' || this.summary.position.auto != 'Y')) {
            this.draw_lastValue(charts, data, st)
          }
        }
      })

      if(Object.keys(this.milestone).length > 0 && this.milestone.apply == 'Y') this.draw_Milestones(charts, cht) 
      if(Object.keys(this.legends).length > 0 && this.legends.apply == 'Y') this.draw_Legends(charts, chtData, cht)

      if(Object.keys(this.summary).length > 0 && this.summary.apply == 'Y') {
        // Mouseover event
        if(this.summary.position && this.summary.position.move == 'Y') {
          
          this.draw_Summary(charts, chtData)

          let overlay = charts
            .append('rect')
            .attr('class', 'gmx-hover-overlay')
            .attr('width', this.chart.width)
            .attr('height', this.chart.height)
            .attr('fill', 'none')
            .attr('pointer-events', 'all') 

          overlay.lower()

          charts.on('mousemove', (event) => {
            let [mouseX] = d3.pointer(event)

            let targetStyle = this.chart.styles.find(f => f.code == this.summary.position.code)
            let searchableData = chtData

            if (targetStyle && targetStyle.sch === 'A') {
              searchableData = chtData.filter(f => f.CDATE <= this.timeline.cutoff.date)
            }

            let closestData = searchableData.reduce((prev, curr) => {
              return Math.abs(curr.mx - mouseX) < Math.abs(prev.mx - mouseX) ? curr : prev
            })

            charts.selectAll('.gmx-dimmable').attr('opacity', 0.4)
            charts.selectAll('.gmx-dimmable-line').attr('opacity', 0.5)
            charts.selectAll(`.gmx-dimmable[data-cdate="${closestData.CDATE}"]`)
                  .attr('opacity', function() {
                      return d3.select(this).attr('data-org-opacity') || 1
                  })

            this.draw_Summary(charts, chtData, closestData);
          })

          charts.on('mouseleave', () => {
            
            charts.selectAll('.gmx-dimmable, .gmx-dimmable-line')
                  .attr('opacity', function() {
                      return d3.select(this).attr('data-org-opacity') || 1
                  });

            this.draw_Summary(charts, chtData)
          })

        } else {
          this.draw_Summary(charts, chtData)
        }
      }
    },


    draw_BarChart(selection, _data, _st, _sn) {

      _data.forEach((d,i)=> {
        
        let value = (d[_st.code] < 0) ? 0 : d[_st.code]
        selection
        .append('rect')
        .attr('class', 'gmx-dimmable')
        .attr('data-cdate', d.CDATE)
        .attr('data-org-opacity', _st.opacity)
        .attr('x', d.bxs[_sn])
        .attr('y', this.chart.height-this.primary.axis(value))
        .attr('width', _st.size).attr('height', this.primary.axis(value))
        .attr('fill', _st.color).attr('opacity', _st.opacity)
        .attr('cursor', this.summary && this.summary.position && this.summary.position.move == 'Y' ? 'pointer' : 'default')
        

        if(_st.vSize > 0 && value > 0) {
          selection
          .append('text')
          .attr('class', 'gmx-dimmable')
          .attr('data-cdate', d.CDATE)
          .attr('data-org-opacity', 1)
          .attr('x', d.bxs[_sn] + (_st.size/2))
          .attr('y', this.chart.height-this.primary.axis(value) -2)
          .attr('font-size', _st.vSize).attr('fill',  _st.vColor)
          .attr('text-anchor', 'middle')
          .text(value)
          
        }
      })
    },


    draw_LineChart(selection, _data, _st) {

      let isMove = (this.summary && this.summary.position && this.summary.position.move == 'Y');

      let delta = _st.delta ? _data.at(-1)[_st.delta] : 0

      let lineFunc = d3.line()
        .x(d => d.mx)
        .y(d => _st.position === 'left' ? this.chart.height - this.primary.axis(d[_st.code]) : this.secondary.axis(d[_st.code]))

      selection
      .append('path')
      .attr('class', 'gmx-dimmable-line')
      .attr('data-org-opacity', _st.opacity)
      .attr('d', lineFunc(_data))
      .attr('stroke', delta != 0 ? this.gmx_deltaValue(delta) : _st.color).attr('stroke-width', _st.size)
      .attr('fill', 'none').attr('opacity', _st.opacity)
      .style('stroke-dasharray', (_st.dash, _st.dash))

      _data.forEach((d,i)=> {

        let cY = _st.position == 'left' ? this.chart.height - this.primary.axis(d[_st.code]) : this.secondary.axis(d[_st.code])

        // Node
        if(_st.node > 0) {
          selection
          .append('circle')
          .attr('class', 'gmx-dimmable')
          .attr('data-cdate', d.CDATE)
          .attr('data-org-opacity', _st.opacity)
          .attr('cx', d.mx)
          .attr('cy', cY)
          .attr('r', _st.node)
          .attr('fill', delta != 0 ? this.gmx_deltaValue(delta) : _st.color).attr('opacity', _st.opacity)
          .attr('cursor', this.summary && this.summary.position && this.summary.position.move == 'Y' ? 'pointer' : 'default')
        }
        // Value
        if(_st.vSize > 0 && d[_st.code] > 0) {
          selection
          .append('text')
          .attr('class', 'gmx-dimmable')
          .attr('data-cdate', d.CDATE)
          .attr('data-org-opacity', 1)
          .attr('x', d.mx)
          .attr('y', cY -4)
          .attr('font-size', _st.vSize).attr('fill',  _st.vColor)
          .attr('text-anchor', 'middle')
          .text(d[_st.code])
        }
      })
    },


    draw_lastValue(selection, _data, _st) {
      let lastOne = _data.find(f=> f.CDATE == this.timeline.cutoff.date)

      let cY = _st.position == 'left' ? this.chart.height - this.primary.axis(lastOne[_st.code]) : this.secondary.axis(lastOne[_st.code])

      if(_st.type == 'LINE') {
        if(!lastOne) return
        selection
        .append('text')
        .attr('class', 'gmx-dimmable-line')
        .attr('data-org-opacity', 1)
        .attr('x', lastOne.mx + 5)
        .attr('y', cY + this.chart.lastValue.tSize*0.36)
        .attr('font-size', this.chart.lastValue.tSize)
        .attr('fill', this.chart.lastValue.delta ? this.gmx_deltaValue(lastOne[this.chart.lastValue.delta]) : _st.vColor)
        .text(lastOne[_st.code])
      }
    },

    getScheduleData(chtData, sch, cutoffDate) {
      if (!sch) return chtData
    
      let m = sch.match(/^([AF])(?:([+-])(\d+))?$/)
      if (!m) return chtData
    
      let [, type, sign, weekStr] = m
      let weeks = weekStr ? parseInt(weekStr, 10) : 0
      let offsetMs = weeks * 7 * 24 * 60 * 60 * 1000
      let offsetSign = sign === '-' ? -1 : 1
    
      let adjustedCutoff = new Date(new Date(cutoffDate).getTime() + offsetSign * offsetMs)
    
      if (type === 'F') {
        return chtData.filter(f => new Date(f.CDATE) >= adjustedCutoff)
      } else {
        return chtData.filter(f => new Date(f.CDATE) <= adjustedCutoff)
      }
    },
  }
}